<div *ngIf="!shouldShowHeader()">
  <router-outlet></router-outlet>
</div>

<sh-page access-bar="solid" no-padding="true" *ngIf="shouldShowHeader()">
  <div>
    <div>
      <app-navigation-header (tabChange)="onTabChange($event)"></app-navigation-header>
    </div>
    <div class="tab-content">
      <app-search *ngIf="activeTab === 0"></app-search>
      <app-spc *ngIf="activeTab === 1"></app-spc>
    </div>
  </div>
</sh-page>
